import androidx.compose.runtime.*
import org.jetbrains.compose.web.attributes.*
import org.jetbrains.compose.web.dom.*

@Composable
internal fun TourRegistrationList(
    players: List<TourPlayerDto>, entries: List<TourEntryDto>, slots: List<TourSlotDto>,
    startedPlayers: Set<String>, disabled: Boolean, saveAttempt: Int,
    savingPlayerId: String?, savedPlayerId: String?, onAssign: (TourPlayerDto, String) -> Unit,
) {
    var search by remember { mutableStateOf("") }
    var onlyStarted by remember { mutableStateOf(false) }
    val entriesByPlayer = entries.associateBy { it.playerId }
    val slotsById = slots.associateBy { it.id }
    val visible = players.filter { p ->
        (!onlyStarted || p.id in startedPlayers) &&
            (search.isBlank() || "${p.name} ${p.fullName.orEmpty()}".contains(search, ignoreCase = true))
    }.sortedWith(compareBy(tourNameComparator) { it.name })
    Div(attrs = { classes("tour-admin-toolbar", "tour-registration-toolbar") }) {
        TourField("Vyhledat hráče pro turnaj", search, required = false) { search = it }
        Label {
            Input(type = InputType.Checkbox) {
                checked(onlyStarted)
                onChange { onlyStarted = it.value }
            }
            Text("Pouze hráči, kteří v tomto ročníku nastoupili")
        }
    }
    P(attrs = { classes("muted") }) {
        Text(slots.sortedBy { it.roundNo }.joinToString(" · ") { slot ->
            "${slot.roundNo}. runda: ${entries.count { it.slotId == slot.id && it.attendance in listOf("registered", "present") }}/${slot.capacity}"
        })
    }
    Div(attrs = {
        classes("table-scroll", "tour-registration-list"); attr("role", "region"); attr("aria-label", "Seznam hráčů pro přihlášení"); attr("tabindex", "0")
        attr("aria-busy", (savingPlayerId != null).toString()); attr("data-save-attempt", saveAttempt.toString())
    }) {
        Table(attrs = { classes("tour-admin-table"); attr("aria-label", "Přihlášky hráčů") }) {
            Thead { Tr { Th { Text("Hráč") }; Th { Text("Přihláška") } } }
            Tbody {
                if (visible.isEmpty()) Tr { Td(attrs = { colspan(2) }) { Text("Nenalezen žádný hráč.") } }
                visible.forEach { player -> key(player.id) {
                    val entry = entriesByPlayer[player.id]?.takeIf { it.attendance != "cancelled" }
                    val assignedSlot = (entry?.slotId ?: entry?.waitlistSlotId).orEmpty()
                    val locked = entry?.handicapFrozenAt != null || slotsById[assignedSlot]?.startedAt != null
                    Tr {
                        Td(attrs = { classes("tour-player-name"); title(player.name) }) {
                            Text(player.fullName?.takeIf { it.isNotBlank() } ?: player.name)
                            if (entry != null && entry.slotId == null) Span(attrs = { classes("tour-result-flag") }) {
                                Text(entry.waitlistSlotId?.let { id -> slotsById[id]?.let { "Náhradník · ${it.roundNo}. runda" } } ?: "V náhradnících")
                            }
                        }
                        Td {
                            key(assignedSlot, entry?.attendance, saveAttempt, slots.map { it.startedAt }) {
                                Label {
                                    Span { Text("Přihláška ${player.name}") }
                                    Select(attrs = {
                                        attr("aria-label", "Přihláška ${player.name}")
                                        if (disabled || locked) disabled()
                                        onChange { event -> event.value?.let { onAssign(player, it) } }
                                    }) {
                                        Option("", attrs = { if (assignedSlot.isEmpty()) selected() }) { Text("Nepřihlášen") }
                                        slots.sortedBy { it.roundNo }.forEach { slot ->
                                            Option(slot.id, attrs = { if (assignedSlot == slot.id) selected(); if (slot.startedAt != null) disabled() }) { Text("${slot.roundNo}. runda") }
                                        }
                                    }
                                }
                            }
                            if (savingPlayerId == player.id || savedPlayerId == player.id) Span(attrs = { classes("tour-registration-save-status"); attr("role", "status") }) {
                                Text(if (savingPlayerId == player.id) "Ukládám…" else "Uloženo")
                            }
                        }
                    }
                } }
            }
        }
    }
}
